var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 40,
    viewBox: "0 0 156 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11_37853)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.863281,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FC4F24"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_11_37853)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.8633,
    cy: 20,
    r: 12,
    fill: "white"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5913 29V20.552H67.9033V17.352H58.5913V10.76H69.8553V7.56H54.9753V29H58.5913ZM76.1478 11.208V7.56H72.5638V11.208H76.1478ZM76.1478 29V13.416H72.5638V29H76.1478ZM83.5228 29V20.264C83.5228 17.704 84.4188 16.008 87.0428 16.008C89.4428 16.008 90.0828 17.32 90.0828 19.24V29H93.6988V18.152C93.6988 14.92 91.8428 13.096 88.8028 13.096C85.6988 13.096 84.0988 15.208 83.5228 17.672V13.416H79.9388V29H83.5228ZM102.602 29.352C104.874 29.352 106.41 28.296 107.082 27.304L105.962 24.104C105.514 25 104.618 25.992 103.402 25.992C102.346 25.992 101.546 25.576 101.546 23.88V16.2H106.314V13.416H101.546V9.256L97.962 11.528V13.416H95.53V16.2H97.962V24.744C97.962 27.496 99.658 29.352 102.602 29.352ZM112.36 29.32C115.624 29.32 117.128 26.888 117.608 24.84V25.992C117.608 28.232 118.92 29 120.584 29H122.792V25.928H121.8C121.224 25.928 120.968 25.704 120.968 25V19.144C120.968 15.304 118.792 13.096 114.92 13.096C111.464 13.096 109.032 14.888 107.816 16.552L109.96 19.112C110.856 17.48 112.488 16.264 114.568 16.264C116.712 16.264 117.416 17.32 117.544 18.888L112.328 21.096C109.8 22.088 108.264 23.432 108.264 25.64C108.264 27.88 109.8 29.32 112.36 29.32ZM111.72 25.096C111.72 24.296 112.264 23.752 113.608 23.144L117.608 21.352V23.016C117.608 25.128 116.008 26.536 113.64 26.536C112.328 26.536 111.72 25.992 111.72 25.096ZM131.465 29.32C134.761 29.32 137.353 27.784 137.353 24.712C137.353 22.472 136.073 21.064 132.585 20.168L130.697 19.688C128.585 19.144 127.753 18.728 127.753 17.608C127.753 16.552 128.681 15.976 130.057 15.976C132.073 15.976 133.737 17 134.825 18.728L136.937 16.488C135.977 14.728 133.641 13.128 130.313 13.128C126.729 13.128 124.393 14.888 124.393 17.8C124.393 20.648 126.665 21.736 129.129 22.312L131.209 22.824C132.937 23.24 134.121 23.624 134.121 24.776C134.121 25.896 133.129 26.44 131.593 26.44C128.809 26.44 126.889 24.84 126.025 23.272L123.913 25.512C125.097 27.976 128.137 29.32 131.465 29.32ZM143.773 29V24.008L146.109 21.704L150.653 29H154.845L148.541 19.56L154.845 13.416H150.461L146.205 17.576L143.645 20.392L143.773 17.384V7.56H140.189V29H143.773Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11_37853",
    x: 0.863281,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11_37853"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_11_37853",
    x: 8.86328,
    y: 8,
    width: 24,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.988235 0 0 0 0 0.309804 0 0 0 0 0.141176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11_37853"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0717bb2b59b6c9761d3b0367d301678f.svg";
export { ForwardRef as ReactComponent };